import { Fragment } from "react";
import { Link, useParams } from "react-router-dom";
import EditThoughtLeadershipResources from "./EditThoughtLeadershipResources";
import { useGetThoughtLeadershipResourcesBySitecoreIdQuery } from "../../../../../reactQueries/AppApi/rqHooksForThoughtLeadershipResources"
import MpgErrorDialog from "../../../../../common/dialog/MpgErrorDialog";

const EditThoughtLeadershipResourcesHome = () => {

  let { sitecoreId } = useParams();
  /**API calls */
  const {
    isSuccess,
    isFetching,
    error,
    data: tlrDataBySitecoreId,
    isError,
  } = useGetThoughtLeadershipResourcesBySitecoreIdQuery({ sitecoreId });

  return (
    <Fragment>
      {
        (!!isFetching)
        && "Wait, Loading...."
      }
      {!!isSuccess && (
        <EditThoughtLeadershipResources
          thoughtLeadershipResourcesDataBySitecoreId={tlrDataBySitecoreId}
        />
      )}

      <MpgErrorDialog
        open={!!isError}
      />
    </Fragment>
  );
};
export default EditThoughtLeadershipResourcesHome;
